module.exports = __webpack_public_path__ + "img/yx1-en.8990bf83.jpg";